<div class="text-center p-4">
    <div>
        <h3>
            LA FICHE A BIEN ÉTÉ ENVOYÉE
        </h3>
    </div>
    <div>
        <h4>
            Vos amis recevront un mail

        </h4>
    </div>
</div>
